import axios from 'axios';

export const axiosi = axios.create({
  withCredentials: true,
  baseURL: 'https://nexoshop-backend-avyq.onrender.com',
});

axiosi.interceptors.request.use((config) => {
  const authUser = JSON.parse(localStorage.getItem('auth_user') || 'null');

  if (authUser?.token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${authUser.token}`;
  }

  return config;
});
